import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export const keyGeolocation: BaseKeyFunction = () => ["geolocation"];
